import LiveActivityFeed from "./LiveActivityFeed";

export default function NormalLiveActivityFeed({ onSelectJob }) {
  return <LiveActivityFeed feedType="user" onSelectJob={onSelectJob} />;
}
